<template>
  <div class="diceBg" :class="{'part': $route.meta.text == '파트너 페이지', 'mega-home-layout': $route.name === 'main'}">
    <div class="diceBgDark dice">
      <main-header v-if="$route.name !== 'partnerCashList' && $route.name !== 'partnerBettingList' && $route.name !== 'partnerList' && $route.name !== 'partnerCalculationList' && $route.name !== 'partnerCalculationUserList' && $route.name !== 'partnerMemberList' && $route.name !== 'partnerMoneyMoveList'" :selectedMenu="selectedMenu" />
      <div class="content0">
          <mega-page-frame><router-view :key="$route.fullPath" /></mega-page-frame>
          <main-footer />
        </div>
    </div>
  </div>

  <slot-list v-if="isSlotOpen" :groupCode="groupCode" :codeName="codeName" :code="code" @isSlot="isSlotOpen = false"></slot-list>
  <loading></loading>
</template>

<script>
import MainHeader from './Header'
import MainFooter from './Footer'
import SlotList from '@/components/game/SlotList'
import Loading from '@/components/common/Loading.vue'
import MegaPageFrame from '@/components/common/MegaPageFrame.vue'

export default {
  name: 'DefaultLayout',
  components: {
    MegaPageFrame,
    Loading,
    SlotList,
    MainHeader,
    MainFooter
  },
  mounted () {
    this.emitter.on('isSlot', (data) => {
      if (data) {
        const groupCode = data.groupCode
        const codeName = data.codeName
        const code = data.code
        this.getSlotOpen(groupCode, codeName, code)
      } else {
        this.isSlotOpen = false
      }
    })
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeMount () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  data () {
    return {
      isSlotOpen: false,
      groupCode: '',
      codeName: '',
      code: '',
      isLoading: false,
      selectedMenu: ''
    }
  },
  methods: {
    scrollToSection (menu) {
      const sectionId = menu.replace(/ /g, '')
      const sectionElement = document.getElementById(sectionId)
      if (sectionElement) {
        sectionElement.scrollIntoView({ behavior: 'smooth' })
      }
    },
    handleScroll () {
      const sectionElements = document.querySelectorAll('section')
      const selectedSection = Array.from(sectionElements).find((section) => {
        const rect = section.getBoundingClientRect()
        return rect.top <= 0 && rect.bottom > 0
      })
      if (selectedSection) {
        this.selectedMenu = selectedSection.id
      }
    },
    getSlotOpen (groupCode, codeName, code) {
      if (this.userData) {
        this.groupCode = groupCode
        this.codeName = codeName
        this.code = code
        this.isSlotOpen = true
      } else {
        this.onCheck('front.error.afterSignin')
      }
    }
  }
}
</script>

<style>
.diceBgDark.dice { display: block; }
.diceBgDark > .content0 { padding-top: 0; }
.mega-home-layout .diceBgDark { background: #171716; }
/* .diceBg {background: url(../assets/img/main_bgobj.png) repeat; background-size: 10%;} */
.diceBgDark {width: 100%; height: 100%; background: #141414; }
.fade-enter {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 0.5s ease-in;
}

.fade-leave-active {
  transition: opacity 0.2s ease-in;
}

.fade-leave-to {
  opacity: 0;
}

.slide-fade-enter {
  transform: translateX(10px);
  opacity: 0;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.2s ease;
}

.slide-fade-leave-to {
  transform: translateX(-10px);
  opacity: 0;
}

.slide-up-enter {
  transform: translateY(185px);
  opacity: 0;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease;
}

.slide-up-leave-to {
  transform: translateY(0px);
  opacity: 0;
}
.part {background: #fff;}
</style>
